import Competition from './client/Competition';

export default {
    GetDataCompetition(params) {
        return Competition.get('/api/staff-challenge', {params});
    },
};
